export const REQUISITES = {
  general: {
    name: {
      name: "Название",
      value: 'ООО "ТУДЕЙПРАЙС ИНВЕСТ”',
    },
    inn: {
      name: "ИНН",
      value: "7814820774",
    },
    kpp: {
      name: "КПП",
      value: "781401001",
    },
    account: {
      name: "Номер счета",
      value: "40702810510001550001",
    },
    ogrn: {
      name: "ОГРН",
      value: "1237800033789",
    },
    bankName: {
      name: "Название банка",
      value: "АО «Тинькофф Банк»",
    },
    bankInn: {
      name: "ИНН Банка",
      value: "7710140679",
    },
    biq: {
      name: "БИК",
      value: "044525974",
    },
    corrAccount: {
      name: "Корр. Счет банка",
      value: "30101810145243434344",
    },
    legalAddress: {
      name: "Юридический адрес",
      value: "197374, г. Санкт-Петербург, ул. Савушкина, д. 126, лит. А, пом. 177-Н",
    },
  },
  getValue: () =>
    Object.keys(REQUISITES.general).map((key) => ({
      [key]: (REQUISITES.general as any)[key].value,
    })),
  getArr: () =>
    Object.keys(REQUISITES.general).map((key) => ({
      name: (REQUISITES.general as any)[key].name,
      value: (REQUISITES.general as any)[key].value,
    })),
};
